import React from "react";
import styled from "styled-components";

const StyledTitle = styled.strong`
  font-size: 13px;
  letter-spacing: 0.2px;
  font-weight: 500;
  color: var(--bs-dark-black);
`;

export default React.memo(StyledTitle);
